import React from "react";
import Body from "./Body";


function Dashboard() {
  

  return (
    <>
    <>
      <Body />
    </>
    </>
  );
}

export default Dashboard;
